import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ZoneStatusCell = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return <>{t(`ordersTable.columns.${value}`)}</>;
};

ZoneStatusCell.propTypes = {
  cell: PropTypes.object,
};

export default ZoneStatusCell;
